export const AffiliateLogos = () => {
  return(
    <div className='flex flex-wrap -mx-4 justify-center'>
      <div className='w-full md:w-1/2 lg:w-1/6 p-4 flex items-center justify-center'>
        <img src="/images/matilda-center-logo.svg" alt="Matilda Center logo" />
      </div>
      <div className='w-full md:w-1/2 lg:w-1/8 p-4 flex items-center justify-center'>
        <img src="/images/university-of-newcastle-logo.svg" alt="University of Newcastle logo" />
      </div>
      <div className='w-full md:w-1/2 lg:w-1/6 p-4 flex items-center justify-center'>
        <img src="/images/monash-university-logo.svg" alt="Monash University logo" />
      </div>
      <div className='w-full md:w-1/2 lg:w-1/6 p-4 flex items-center justify-center'>
        <img src="/images/usi-sc-logo.svg" alt="USI logo" />
      </div>
      <div className='w-full md:w-1/2 lg:w-1/6 p-4 flex items-center justify-center'>
        <img src="/images/florida-state-university-logo.png" alt="Florida State University logo" />
      </div>
    </div>
  )
};
